import { AxiosInstance } from 'axios';

export interface DreamChatDTO {
  id: string;
  userId: string;
  title: string;
  createdAt: string;
  updatedAt: string;
}

export interface DreamChatMessageDTO {
  id: string;
  chatId: string;
  role: 'user' | 'assistant';
  content: string;
  imageUrl?: string;
  imageType?: 'uploaded' | 'generated' | 'transformed';
  createdAt: string;
}

export interface ChatDetailResponse {
  chat: DreamChatDTO;
  messages: DreamChatMessageDTO[];
}

export interface SendMessageParams {
  content: string;
  imageBase64?: string;
  imageUrl?: string;
}

export interface TransformImageParams {
  imagePath: string;
  style: 'anime' | 'illustration' | 'cartoon' | 'fantasy' | 'photographic';
  prompt?: string;
}

export default class DreamChatService {
  constructor(private axios: AxiosInstance) {}

  // 대화 목록 조회
  getChatList = async (): Promise<{ success: boolean; data: DreamChatDTO[] }> => {
    const { data } = await this.axios.get('/dream-chat');
    return data;
  };

  // 새 대화 생성
  createChat = async (title?: string): Promise<{ success: boolean; data: DreamChatDTO }> => {
    const { data } = await this.axios.post('/dream-chat', { title });
    return data;
  };

  // 대화 메시지 조회
  getMessages = async (chatId: string): Promise<{ success: boolean; data: ChatDetailResponse }> => {
    const { data } = await this.axios.get(`/dream-chat/${chatId}`);
    return data;
  };

  // 대화 삭제
  deleteChat = async (chatId: string): Promise<{ success: boolean; message: string }> => {
    const { data } = await this.axios.delete(`/dream-chat/${chatId}`);
    return data;
  };

  // 이미지 업로드
  uploadImage = async (file: File): Promise<{ success: boolean; data: { imageUrl: string; fileName: string } }> => {
    const formData = new FormData();
    formData.append('image', file);
    const { data } = await this.axios.post('/dream-chat/image/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  };

  // 이미지 변환
  transformImage = async (params: TransformImageParams): Promise<{ success: boolean; data: { imageUrl: string; fileName: string } }> => {
    const { data } = await this.axios.post('/dream-chat/image/transform', params);
    return data;
  };

  // 업로드만 하고 보내지 않은 이미지 서버에서 삭제
  deleteUploadedImage = async (
    imageUrl: string
  ): Promise<{ success: boolean; data: { deleted: boolean } }> => {
    const { data } = await this.axios.delete('/dream-chat/image', { data: { imageUrl } });
    return data;
  };

  // 저장된 메시지의 이미지 제거
  clearMessageImage = async (
    chatId: string,
    messageId: string
  ): Promise<{ success: boolean; message: string }> => {
    const { data } = await this.axios.delete(`/dream-chat/${chatId}/messages/${messageId}/image`);
    return data;
  };
}
